import React from "react"

export const renderMultipleComponents = (
  component: JSX.Element,
  count: number
) =>
  new Array(count)
    .fill(component)
    .map((component, index) => React.cloneElement(component, { key: index }))
